import { ThemeUICSSObject } from 'theme-ui';

export const rootStyles: ThemeUICSSObject = {
  fontFamily: 'body',
  fontSize: 'body',
  fontWeight: 'medium',
  lineHeight: 'body',
  letterSpacing: 'normal',
  button: {
    padding: 0,
    background: 'transparent',
    border: 'none',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    fontFamily: 'inherit',
    cursor: 'pointer',
    ':disabled': {
      cursor: 'auto',
    },
  },
  b: {
    fontWeight: 'semibold',
  },
};
